import styled from '@emotion/styled';

export const Container = styled.div`
  flex: 0 0 auto;
  max-height: 550px;
  padding: 12px 10px;
  overflow-y: auto;
  > div {
    color: #fbc150;
    text-indent: 12px;
  }
  > .ant-empty {
    flex-direction: column;
    margin: 16px;
  }
  > section {
    margin-top: 12px;
  }
`;

export const Title = styled.h3`
  position: relative;
  font-size: 14px;
  text-indent: 12px;
  font-weight: 600;
  &::before {
    content: '';
    display: inline-block;
    position: absolute;
    top: 3px;
    left: 0;
    width: 4px;
    height: 16px;
    background: var(--ant-primary-color);
  }
  > span {
    font-weight: normal;
    color: #777777;
  }
`;
